var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("article", { staticClass: "projects-item" }, [
    _c("a", { staticClass: "projects-item__link", attrs: { href: _vm.link } }, [
      _c("div", { staticClass: "projects-item__image" }, [
        _c("img", {
          attrs: { src: _vm.image, alt: _vm.title, title: _vm.title }
        })
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "projects-item__text-wrap" }, [
        _c("div", { staticClass: "projects-item__text" }, [
          _c("h2", { staticClass: "projects-item__content-title" }, [
            _vm._v(_vm._s(_vm.title))
          ]),
          _vm._v(" "),
          _c("span", { staticClass: "projects-item__content-filters" }, [
            _vm._v(_vm._s(_vm.getFilters))
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "projects-item__overlay" })
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }